"use client"

import { useEffect } from "react"
import styles from "./SuccessModal.module.css"

const SuccessModal = ({ isOpen, onClose, message, type = "single" }) => {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose()
      }, 3000) // Auto close after 3 seconds

      return () => clearTimeout(timer)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.successModal}>
        <div className={styles.modalContent}>
          <div className={styles.iconContainer}>
            <svg className={styles.successIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" fill="#10B981" />
              <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>

          <div className={styles.messageContainer}>
            <h3 className={styles.title}>
              {type === "bulk" ? "Shifts Approved Successfully!" : "Shift Approved Successfully!"}
            </h3>
            <p className={styles.message}>{message}</p>
          </div>

          <button className={styles.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>

        <div className={styles.progressBar}>
          <div className={styles.progressFill}></div>
        </div>
      </div>
    </div>
  )
}

export default SuccessModal
